import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useModal } from "_shared/contexts/ModalContext";
import { useUserSubscriptionsQuery } from "_shared/graphql";

function SubscriptionAlert() {
  const { onErrorMsg } = useModal();
  const [trialDate, setTrialDate] = useState<number>();
  const [expired, setExpired] = useState(false);
  const [cancelled, setCancelled] = useState(false);

  const history = useHistory();
  const { data } = useUserSubscriptionsQuery();

  useEffect(() => {
    if (!data) return;
    const userSubscriptions = data.subscriptions.filter(
      (sub) => sub.subscribed,
    );

    const plans = userSubscriptions.filter(
      (sub) => sub.subscribed && sub.id.endsWith("plan"),
    );
    if (!plans.length) return setCancelled(true);

    const trialDuration = plans.find((sub) => sub.subscribed?.trial)?.subscribed
      ?.trial;
    if (!trialDuration) return;

    // TODO: this logic should be on the backend
    const todayDate = new Date();
    const trialDate = new Date(userSubscriptions[0].subscribed?.date_created);
    trialDate.setDate(trialDate.getDate() + trialDuration);

    if (todayDate < trialDate) {
      setTrialDate(trialDate.getDate() - todayDate.getDate());
    } else {
      setExpired(true);
    }
  }, [data]);

  useEffect(() => {
    if (!expired && !cancelled) return;
    history.push("/account/manage-subscriptions");
    onErrorMsg(
      expired
        ? `Your trial period is over, please choose a plan to continue.`
        : cancelled
        ? `Your plan is cancelled, please resubscribe to a plan to view your dashboard.`
        : ``,
    );
  }, [expired, cancelled]);

  return (
    <div>
      {trialDate && (
        <div
          onClick={() => history.push("/account/manage-subscriptions")}
          style={{
            cursor: "pointer",
            backgroundColor: "#7FDA48",
            borderRadius: 20,
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 5,
            paddingBottom: 5,
            fontWeight: "bold",
            marginRight: 40,
          }}
        >{`Trial Period ${trialDate} days left`}</div>
      )}
    </div>
  );
}

export default SubscriptionAlert;
